<template>
  <div v-cloak>
    <div>

    <b-container v-show="(!isBusy && !errored)" fluid> 
       <b-row>
          <b-col md="5" class="my-1 col-centered">
        
        <b-form-group label-cols-sm="2" label="" class="mb-0" v-show="dataRows>perPage">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to search PO List..."></b-form-input>
            <b-input-group-append>
              <b-button class="ml-1" variant="outline-dark" :disabled="!filter" @click="filter = ''"> &#10008; Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      
      </b-col>
       </b-row>
    </b-container>  

      <div id="potable">
        <b-table
          responsive
          selectable
          select-mode="single"
          small
          striped
          outlined
          head-variant="light"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :busy="isBusy"
          :items="data"
          :fields="fields"
          @filtered="onFiltered"
          @row-selected="rowSelected"
        >

      <template v-slot:cell(open)="data">
       <div v-if="!data.item.open"> &#10004; </div>
      </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner></b-spinner>
            <div>
              <strong>Loading...</strong>
            </div>
          </div>
        </b-table>
      </div>
    </div>

    <b-pagination v-show="totalRows>perPage"
      v-model="currentPage"
      align="center"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="potable"
      hide-ellipsis>
    </b-pagination>

    <div v-if="errored">
      <p class="text-danger">An error occurred loading data.</p>
      <p>{{ error }}</p>
      <p>
        <b-button type="button" @click="reload">Reload</b-button>
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "PoList",
  props: {},
  components: {},

  data: function() {
    return {
      projectId: this.$route.params.id, 
      project: null,
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      filter: null,
      selectedItem: [],
      selectedId : null,
      isBusy: true,
      data: [],
      dataRows: 0,
      loading: true,
      loaded: false,
      errored: false, 
      error: "",

      fields: [
       
        {
          key: "pO_Number",
          sortable: true,
          label: "PO Number",
          isRowHeader: true
        },
        {
          key: "pO_Date",
          sortable: true,
          label: "PO Date"
        },
        {
          key: "reference",
          sortable: true,
          label: "Reference"
        },        
        {
          key: "vendor",
          sortable: true,
          label: "Vendor",
        },
        {
          key: "open",
          sortable: true,
          label: "Cmpl",
          class: "text-center"
        } 
      ]
    };
  },

 computed: {

    },

  methods: {
    reload() {
      this.errored = false;
      this.isBusy = true;
      this.fetchData();
    },
     rowSelected(items) {
       if (items.length > 0) {
        this.selectedItem = items[0];
        this.selectedId = this.selectedItem.pO_Number;
        this.$router.push({name: 'PurchaseOrder', params: { id: this.projectId, poId: this.selectedId  } }, () =>{} );
       }

      },

 fetchData() {
      this.$auth.acquireToken().then(token => {
          this.$http.get(
            "api/PurchaseOrders/" + this.projectId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          )
          .then(response => {
            this.data = response.data;
            this.totalRows = this.data.length;
            this.dataRows = this.data.length;
            this.loaded = true;
          })
          .catch(error => {
            console.log (error);
            this.errored = true;
            this.loaded = false;
            this.data = [];
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },

     onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
  },

  mounted: function() {
      this.errored = false;
      this.isBusy = true;
      this.fetchData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#potable {
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  padding-top: 10px;
}

@media (max-width: 400px) {
    #potable {
    font-size:.75rem;
    }
}

.col-centered{
    float: none;
    margin: 0 auto;
}

.pagination > li > a,
.pagination > li > span {
    color: darkred;  
}

</style>